import AddBeneficiaryError from './AddBeneficiaryError';
class InvalidFormatBrithdate extends AddBeneficiaryError {
    constructor(options) {
        super('Birthdate does not match the correct format', options);
    }
}
export default InvalidFormatBrithdate;
